import { styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const Overlay = styled("div")({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 1,
});

const Number = styled(Typography)({
  fontSize: "4rem",
  fontWeight: 700,
  color: "#fff",
});

const CountdownOverlay = ({ value }) => (
  <Overlay role="timer" aria-live="assertive" aria-atomic="true">
    <Number aria-label={`Recording starts in ${value}`}>{value}</Number>
  </Overlay>
);

CountdownOverlay.propTypes = {
  value: PropTypes.number.isRequired,
};

export default CountdownOverlay;
